import React from "react";

const Insurance = () => {
  return (
    <div className="insurance-bg p-5">
      <div className="container">
        <div className="">
          <h2 className="text-uppercase p-4 text-black f-20-b text-center shadow-lg ">Accepted Insurance Providers In Kentucky:</h2>
        </div>
        <div className="container p-0 m-0">
        <div className="row g-3 p-0 my-4 m-auto text-center d-flex justify-content-center">
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/Medicare.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/aetna.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/BlueCross.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/cigna.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/Humana.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/Medicaid.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/UnitedHealthCare.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/Aetna-Better-Health-Logo-300x300-1.jpg"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/optumImg.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/Beacon.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/CareSource.webp"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/MolinaHealthcare.png"/></div>
            <div className="col-md-4 col-6"><img className="img-fluid insurance-logos" src="Images/wellcare-health-plans-logo.png"/></div>

            <h2 className="text-uppercase p-4 text-black f-20-b text-center shadow-lg ">Please note that in Iowa, Washington, and Wisconsin, we accept only cash payments.</h2>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Insurance;
